// Vague 6a (fondateur, 26 sept.) : version française de golf6App.nl.ts. Les boutons d'Apple et de
// Google sont écrits comme sur un appareil en français (« Sur l'écran d'accueil », « Ajouter »,
// « Installer l'application »). Ton : tutoiement, phrases courtes.
export const appGolf6Fr = {
    tabletGuide: {
        title: 'Comment relier un iPad au tableau',
        intro: 'Trois étapes, environ une minute. Garde cette page ouverte.',
        step1Title: 'Ouvre Safari sur l’iPad',
        step1Body: 'Tape cette adresse dans la barre d’adresse :',
        copy: 'Copier',
        copied: 'Copié',
        copyLabel: 'Copier l’adresse {url}',
        step2Title: 'Le tableau affiche un code',
        step2Body: 'Huit caractères, par exemple ABCD-2345. Laisse l’iPad tel quel.',
        step3Title: 'Saisis le code ici',
        step3Body: 'Choisis aussi la pièce où le tableau est accroché. Le tableau apparaît en quelques secondes.',
        enterCode: 'Saisir le code',
        orTitle: 'Tu préfères ne rien taper ?',
        orBody: 'Crée un code QR et scanne-le avec l’appareil photo de l’iPad. Le tableau se relie tout seul.',
        qrButton: 'Relier avec un code QR',
        tipsTitle: 'Conseils pour un tableau au mur',
        tips: [
            {
                title: 'Mets le tableau sur l’écran d’accueil',
                body: 'Il s’ouvre alors en plein écran, sans barre d’adresse. Fais-le avant de relier : une app sur l’écran d’accueil a sa propre mémoire et se relie à part.',
            },
            {
                title: 'Verrouillage automatique : Jamais',
                body: 'Réglages › Luminosité et affichage › Verrouillage automatique › Jamais. Laisse l’iPad sur son chargeur, l’écran reste allumé.',
            },
            {
                title: 'Accès guidé',
                body: 'Réglages › Accessibilité › Accès guidé (iPad plus ancien sous iOS 12 : Réglages › Général › Accessibilité › Accès guidé) : active-le et choisis un code. Ouvre le tableau et appuie trois fois rapidement sur le bouton principal (ou le bouton du haut). Les enfants restent ainsi dans le tableau.',
            },
            {
                title: 'Touche une fois pour le son',
                body: 'Un iPad ne joue du son qu’après un toucher. Touche le tableau une fois après le démarrage : tu entendras l’adhan et les appels.',
            },
        ],
        homeScreenHow: 'Comment le mettre sur l’écran d’accueil ?',
    },
    qr: {
        title: 'Relier avec un code QR',
        intro: 'L’iPad scanne le code avec son appareil photo et se relie tout seul. Rien à taper.',
        room: 'Pièce',
        name: 'Nom de la tablette',
        defaultName: 'iPad {room}',
        create: 'Créer un code QR',
        scanTitle: 'Scanne avec l’appareil photo de l’iPad',
        scanSteps: [
            'Ouvre l’app Appareil photo sur l’iPad.',
            'Vise ce code jusqu’à ce qu’une notification apparaisse en haut.',
            'Touche la notification. Le tableau s’ouvre dans Safari et se relie tout seul.',
        ],
        validFor: 'Encore valable {time} · fonctionne une fois',
        qrLabel: 'Code QR pour relier une tablette dans {room}',
        waiting: 'En attente du scan par l’iPad…',
        claimed: '{name} est relié',
        claimedBody: 'Le tableau de {room} affiche maintenant l’agenda.',
        expired: 'Ce code QR a expiré',
        expiredBody: 'Un code QR fonctionne 10 minutes et une seule fois. Crée-en un nouveau.',
        again: 'Nouveau code QR',
        done: 'Terminé',
        safariNote: 'Le code QR ouvre le tableau dans Safari. Le tableau est déjà sur l’écran d’accueil ? Relie alors cette app avec le code.',
        keepPrivate: 'Ne montre pas ce code à d’autres : qui le scanne obtient le tableau de ta famille.',
    },
    phoneQr: {
        title: 'Ouvrir AMUMIN sur ton téléphone',
        body: 'Scanne ce code avec l’appareil photo de ton téléphone. Ajoute ensuite AMUMIN à ton écran d’accueil.',
        label: 'Code QR vers {url}',
    },
    install: {
        platform: 'Quel appareil ?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Ordinateur',
        thisDevice: '{platform} (cet appareil)',
        iosSteps: [
            'Ouvre {url} dans Safari.',
            'Touche Partager : le carré avec la flèche vers le haut. Sur un iPhone, il est en bas ; sur un iPad, en haut à côté de l’adresse. Tu ne le vois pas ? Touche d’abord ···.',
            'Balaie ou fais défiler le menu de partage jusqu’à Sur l’écran d’accueil, puis touche-le. Sur un iPad plus ancien, c’est dans la rangée du bas : balaie-la vers la gauche.',
            'Touche Ajouter en haut à droite.',
            'Ouvre désormais {app} avec l’icône de ton écran d’accueil.',
        ],
        androidSteps: [
            'Ouvre {url} dans Chrome.',
            'Touche les trois points en haut à droite.',
            'Choisis Installer l’application (ou Ajouter à l’écran d’accueil).',
            'Touche Installer. {app} est maintenant parmi tes applis.',
        ],
        desktopSteps: [
            'Ouvre {url} dans Chrome ou Edge.',
            'Clique sur l’icône d’installation à droite de la barre d’adresse (un petit écran avec une flèche).',
            'Clique sur Installer. {app} s’ouvre désormais dans sa propre fenêtre.',
        ],
        ui: {
            share: 'Partager',
            addToHome: 'Sur l’écran d’accueil',
            add: 'Ajouter',
            cancel: 'Annuler',
            installApp: 'Installer l’application',
            install: 'Installer',
        },
        pictureLabel: 'Exemple de l’étape {n}',
    },
    stepUp: {
        which: 'Saisis ton propre mot de passe AMUMIN : celui avec lequel tu te connectes sur {host}.',
        notThese: 'Donc ni le mot de passe du Wi-Fi, ni le code de l’iPad.',
        why: 'Nous le demandons pour les étapes importantes, comme relier une tablette. Ensuite, nous ne le redemandons pas pendant 10 minutes.',
        account: 'Ton compte',
        password: 'Ton mot de passe AMUMIN',
        forgot: 'Mot de passe oublié ?',
    },
    tasks: {
        forWho: 'Pour qui ?',
        forWhoHint: 'Les enfants sont déjà sélectionnés. Touche un prénom pour ajouter ou retirer quelqu’un.',
        nobody: 'Choisis au moins une personne.',
    },
    werklijstDoc: {
        read: 'Lire le conseil',
        readLabel: 'Lire le conseil : {title}',
        loading: 'Chargement du conseil…',
        missing: 'Ce conseil n’est pas encore dans cette version de l’app.',
        error: 'Le conseil ne peut pas être lu pour l’instant. Réessaie plus tard.',
        back: 'Retour',
        external: '(s’ouvre dans une nouvelle fenêtre)',
    },
};
//# sourceMappingURL=golf6App.fr.js.map